import React from 'react';
import { P2pInform } from './p2p';
import { AffiliationInform } from './affiliation';
import { SponsoredType } from '../types';
import { SponsoredInform } from './sponsored';

interface InformType {
  affiliation?: boolean;
  bestPick?: boolean;
  sponsored?: SponsoredType;
  tags?: string[];
}

export const Inform = ({ affiliation, bestPick, tags, sponsored }: InformType) => {
  return (
    <div>
      {(affiliation || bestPick) && <AffiliationInform />}
      {tags?.includes('peer-to-peer') && <P2pInform />}
      {sponsored.isSponsored && <SponsoredInform sponsors={sponsored.sponsors} />}
    </div>
  );
};
